import styled from 'styled-components';
import Select from 'antd/lib/select';

export const PreFlightsTitle = styled.h1`
  font-weight: bold;
  font-size: 2rem;
  font-family: Sarabun;
`;

export const PreFlightsFilters = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 3rem;
`;

export const TableTools = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3rem 0;
`;

export const SelectDocumentType = styled(Select)`
  margin-right: 1rem;
  margin-left: 0.7rem;
`;
